import { render } from "./PageRecieps.vue?vue&type=template&id=7a5f781d"
import script from "./PageRecieps.vue?vue&type=script&lang=js"
export * from "./PageRecieps.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__